import { FC, Suspense, useEffect } from 'react';
import { matchPath, Route, Routes, useLocation } from 'react-router-dom';
import { PageLoader } from 'widgets/PageLoader';
import { AppRoutesProps, routeConfig } from '../config/routeConfig';
import { RequireAuth } from './RequireAuth';

export const AppRouter: FC = () => {
  const location = useLocation();

  useEffect(() => {
    const route = Object.values(routeConfig).find(({ path }) => {
      if (!path) {
        return false;
      }

      return matchPath({ path, end: true }, location.pathname);
    });

    document.title = route?.title ?? 'Private Gate';
  }, [location.pathname]);

  const renderWithWrapper = ({ path, element, authOnly }: AppRoutesProps) => (
    <Route
      key={path}
      path={path}
      element={authOnly ? <RequireAuth>{element}</RequireAuth> : element}
    ></Route>
  );

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>{Object.values(routeConfig).map(renderWithWrapper)}</Routes>
    </Suspense>
  );
};
